import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '../../../../services/other/shared.service';
import { ExecutionResponse } from 'src/app/models/support/execution-response';
import { ResponseState } from 'src/app/models/support/response-state';
import { TranslateService } from '@ngx-translate/core';
import { SurePayService } from 'src/app/services/payment-devices/sure-pay.service';
import { OTPResponse } from 'src/app/models/classes/transactions/transaction-otp-response';
import { ClientNotificationOTPType } from 'src/app/models/enums/transaction-otp-type';
import { TransactionOTPService } from 'src/app/services/payment-devices/transaction-otp-.service';
import { HandleNotifyClientWithOTPModel } from 'src/app/models/classes/transactions/handle-notify-client-with-OTP-model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-handle-transaction-otp',
  templateUrl: './modal-handle-transaction-otp.component.html',
  styleUrls: ['./modal-handle-transaction-otp.component.scss'],
})
export class ModalHandleTransactionOTPComponent implements OnInit {
  @Output() OTPChanged = new EventEmitter<OTPResponse>();
  @Input() Form: any;
  @Input() FromEdit: boolean;
  public OTPCode: string;
  public loading: boolean;
  public CurrentTransactionOTPType: ClientNotificationOTPType;
  public transactionOTPResponse: OTPResponse =
    new OTPResponse();
  public seconds60: number;
  public tickTock: any;
  @ViewChild('seconds', { static: false }) seconds: ElementRef;

  constructor(
    public activeModal: NgbActiveModal,
    public sharedService: SharedService,
    public surePayService: SurePayService,
    private ngbModal: NgbModal,
    public toaster: ToastrService,
    public translateService: TranslateService,
    public transactionOTPService: TransactionOTPService
  ) { }

  public get transactionOTPType(): typeof ClientNotificationOTPType {
    return ClientNotificationOTPType;
  }

  ngOnInit(): void {
    this.GetCurrentTransactionOTPType();
  }

  ngOnDestroy(): void {

    this.transactionOTPResponse.OTPCode = this.OTPCode;
    this.OTPChanged.emit(this.transactionOTPResponse);
  }

  GetCurrentTransactionOTPType() {


    if (this.Form) {
      var model = this.Form;
      var payBooking = model.TransactionBookingId > 0;
      var hasDiscount = model.BookingOrTransactionDiscountValueAll > 0;
      if (payBooking)
        this.CurrentTransactionOTPType = ClientNotificationOTPType.PayBookingAndChangeStatus;
      else if (hasDiscount)
        this.CurrentTransactionOTPType = ClientNotificationOTPType.BillDiscount;
      else {
        this.CurrentTransactionOTPType = ClientNotificationOTPType.PackageItemsWorkDone;
      }
      var clientNotificationOTPId = model.ClientNotificationOTPId;
      var OTPCode = model.TransactionOTPCode;

      this.transactionOTPResponse.ClientNotificationOTPId = clientNotificationOTPId;
      this.transactionOTPResponse.OTPCode = OTPCode;
      this.OTPCode = OTPCode;
    }
  }

  SendOTP() {

    var model = new HandleNotifyClientWithOTPModel();

    model.TransactionOTPType = this.CurrentTransactionOTPType;
    model.BookingId =
      this.CurrentTransactionOTPType == ClientNotificationOTPType.PayBookingAndChangeStatus
        ? this.Form.TransactionBookingId
        : null;
    model.TotalDiscount =
      this.CurrentTransactionOTPType == ClientNotificationOTPType.BillDiscount
        ? this.Form.BookingOrTransactionDiscountValueAll
        : null;
    model.ClientId = this.Form.BookingOrTransactionClientId;
    model.TotalAmount = this.Form.BookingOrTransactionTotalPrice;
    model.TotalAmount = model.TotalAmount;
    // **** PackageItemsWorkDone *****
    model.TransactionItemId = this.Form.TransactionItemId
    model.WorkDoneItemsCount = this.Form.WorkDoneItemsCount
    this.loading = true;

    this.transactionOTPService
      .handleNotifyClientWithOTP(model)
      .subscribe((response: ExecutionResponse<number>) => {
        if (response.State == ResponseState.Success) {
          if (response.Result > 0) {
            this.transactionOTPResponse.ClientNotificationOTPId = response.Result;
          }

          this.toaster.success(response.Message);
          this.TickTock();
        }
        this.loading = false;
      });
  }

  TickTock() {
    this.seconds60 = 60;
    this.tickTock = setInterval(() => {
      this.seconds60 = this.seconds60 - 1;
      this.seconds.nativeElement.innerText = this.seconds60;
      if (this.seconds60 == 0) {
        clearInterval(this.tickTock);
      }
    }, 1000);
  }
}
